<template>
  <div>
    <div class="form-row div-valign" v-if="this.specificVo.beneGroup == 'MEA' && this.lgTypeVo == 5">
      <div class="form-group col-md-6">
        <label>บัญชีแสดงสัญญา</label><span class="required">*</span>
        <input 
          v-model="caNo" 
          name="caNo" 
          v-validate="{required:true,max:20}"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag!=='Y'"
          :class="{'input': true, 'is-danger': errors.has('caNo') }"
          type="text" class="form-control">
        <span v-show="errors.has('caNo')" class="help is-danger">กรุณากรอก บัญชีแสดงสัญญา</span>
      </div>
      <div class="form-group col-md-6">
        <label>เครื่องวัดไฟฟ้าเลขที่</label><span class="required">*</span>
        <input 
        v-model="meterNo" 
        name="meterNo" 
        v-validate="{required:true,max:20}"
        
        :disabled="(this.reqType !== 1  && this.appVo.modifyFlag!=='Y')"
        :class="{'input': true, 'is-danger': errors.has('meterNo') }"
        type="text" class="form-control" >
        <span v-show="errors.has('meterNo')" class="help is-danger">กรุณากรอก เครื่องวัดไฟฟ้าเลขที่</span>
      </div>
    </div>
    <div class="form-row div-valign" v-if="this.specificVo.ctrNoFlag == 'Y'">
      <div class="form-group col-md-6">
        <label>{{ txtCtrNo }}</label
        ><span class="required" v-if="this.isRequiredCtrNo">*</span>
        <input
          v-model="ctrNo"
          name="ctrNo"
          data-vv-as="ข้อมูล"
          v-validate="{ required: this.isRequiredCtrNo }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('ctrNo') }"
          maxlength="50"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('ctrNo')" class="help is-danger">กรุณากรอก {{txtCtrNo}}</span>
      </div>
    </div>
    <div class="form-row div-valign" v-if="this.specificVo.ctrNameFlag == 'Y'">
      <div class="form-group col-md-6">
        <label>{{ txtCtrName }}</label>
        <span class="required" v-if="this.isRequiredCtrName">*</span>
        <input
          v-model="ctrName"
          name="ctrName"
          data-vv-as="ชื่อสัญญา"
          v-validate="{ required: this.isRequiredCtrName }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('ctrName') }"
          maxlength="200"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('ctrName')" class="help is-danger">กรุณากรอก {{txtCtrName}}</span>
      </div>
    </div>

    <div class="form-row div-valign" v-if="this.specificVo.ctrDateFlag == 'Y'">
      <div class="form-group col-md-6">
        <label>{{ txtCtrDate }}</label><span class="required" v-if="this.isRequiredCtrDate">*   </span>
        <span class="text-white" v-if="this.txtCtrDate.length < 17">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <date-picker
          v-model="ctrDate"
          name="ctrDate"
          ref="ctrDate"
          format="DD/MM/YYYY"
          v-validate="{ required: this.isRequiredCtrDate }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          data-vv-as="ข้อมูล"
          lang="th"
          :class="{ input: true, 'is-danger': errors.has('ctrDate') }"
          placeholder
        ></date-picker>
        <span v-show="errors.has('ctrDate')" class="help is-danger">กรุณากรอก {{txtCtrDate}}</span>
      </div>
    </div>

    <div class="form-row div-valign" v-if="this.specificVo.hcodeFlag == 'Y'">
      <div class="form-group col-md-6" v-if="this.specificVo.hcodeFlag == 'Y'">
        <label> รหัสสถานบริการ (H Code) </label><span class="required" v-if="this.isRequiredBeneRemark">*</span>
        <input
          v-model="hospitalCode"
          name="hospitalCode"
          data-vv-as="รหัสสถานบริการ (H Code)"
          v-validate="{ required: this.isRequiredBeneRemark }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('hospitalCode') }"
          maxlength="5"
          @blur="gethospitalName()"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('hospitalCode')" class="help is-danger">{{
          errors.first("hospitalCode")
        }}</span>
      </div>
    </div>
    <div class="form-row div-valign" v-if=" this.specificVo.hnameFlag == 'Y'">
      <div class="form-group col-md-12" v-if="this.specificVo.hnameFlag == 'Y'">
        <label> ชื่อสถานบริการ </label><span class="required" v-if="this.isRequiredBeneRemark">*</span>
        <input
          v-model="hospitalName"
          name="hospitalName"
          data-vv-as="ชื่อสถานบริการ"
          v-validate="{ required: this.isRequiredBeneRemark }"
          disabled="true"
          :class="{ input: true, 'is-danger': errors.has('hospitalName') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('hospitalName')" class="help is-danger">{{
          errors.first("hospitalName")
        }}</span>
      </div>
    </div>

    <div class="form-row div-valign" v-if="this.specificVo.contractTypeFlag == 'Y'">
      <div class="form-group col-md-6">
        <label>ประเภทสัญญา</label
        ><span class="required" v-if="this.isRequiredBeneRemark">*</span>
        <select
          v-model="contractTypeId"
          name="contractTypeId"
          class="form-control"
          disabled
          v-validate="{ required: this.isRequiredBeneRemark }"
          :class="{ input: true, 'is-danger': errors.has('contractTypeId') }"
        >
          <option value="">กรุณาเลือก</option>
          <option
            v-for="option in contractTypeList"
            v-bind:value="{
              contractTypeId: option.contractTypeId,
              contractTypeDesc: option.contractTypeDesc,
            }"
            :key="`${option.contractTypeId}-${option.contractTypeDesc}`"
            >{{ option.contractTypeDesc }}</option
          >
        </select>
        <span v-show="errors.has('contractTypeId')" class="help is-danger">กรุณากรอก ประเภทสัญญา</span>
      </div>
    </div>

    <div class="form-row div-valign" v-if="this.specificVo.beneRemarkFlag == 'Y'">
      <div class="form-group col-md-12">
        <label> {{labelBeneRemark}} </label
        ><span class="required" v-if="this.isRequiredBeneRemark">*</span>
        <input
          v-model="beneficiaryRemark"
          name="beneficiaryRemark"
          data-vv-as="ข้อมูล"
          v-validate="{ required: this.isRequiredBeneRemark }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y' && this.specificVo.beneGroup !== 'NHSO'"
          :class="{ input: true, 'is-danger': errors.has('beneficiaryRemark') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('beneficiaryRemark')" class="help is-danger">กรุณากรอก {{labelBeneRemark}}</span>
      </div>
    </div>

    <div class="form-row div-valign" v-if="this.specificVo.dealerCodeFlag == 'Y'">
      <div class="form-group col-md-6">
        <label> {{labelDealerCode}} </label
        ><span class="required" v-if="this.isRequiredDealerCode">*</span>
        <input
          v-model="dealerCode"
          name="dealerCode"
          data-vv-as="ข้อมูล"
          v-validate="{ required: this.isRequiredDealerCode }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('dealerCode') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('dealerCode')" class="help is-danger">กรุณากรอก {{labelDealerCode}}</span>
      </div>
    </div>

    <div class="form-row div-valign" v-if="this.specificVo.ctrDatePEAFlag == 'Y'">
      <div class="form-group col-md-6">
        <label>สัญญาลงวันที่</label
        ><span class="required" v-if="this.isRequiredCtrDatePEA">*</span>
        <date-picker
          v-model="ctrDatePEA"
          name="ctrDatePEA"
          ref="ctrDatePEA"
          format="DD/MM/YYYY"
          data-vv-as="สัญญาลงวันที่"
          v-validate="{ required: this.isRequiredCtrDatePEA }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          lang="th"
          :class="{ input: true, 'is-danger': errors.has('ctrDate') }"
          placeholder
        ></date-picker>
        <span v-show="errors.has('ctrDatePEA')" class="help is-danger">{{
          errors.first("ctrDatePEA")
        }}</span>
      </div>
    </div>

    <div class="form-row div-valign" v-if="this.specificVo.lgDescription3Flag == 'Y'">
      <div class="form-group col-md-6">
        <label>{{ labelLgDescription3 }}</label>
        <span class="required" v-if="this.isRequiredLgDescription3">*</span>
        <input
          v-model="lgDescription3"
          name="lgDescription3"
          data-vv-as="ชื่อสัญญาหลัก"
          v-validate="{ required: this.isRequiredLgDescription3 }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('lgDescription3') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('lgDescription3')" class="help is-danger">กรุณากรอก {{labelLgDescription3}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.projectIdFlag == 'Y'">
        <label style="display: contents;">{{ labelProjectId }}</label
        ><span class="required" v-if="this.isRequiredProjectId">*</span>
        <input
          v-model="projectId"
          name="projectId"
          data-vv-as="เลขที่โครงการ"
          v-validate="{ required: this.isRequiredProjectId }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('projectId') }"
          maxlength="50"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('projectId')" class="help is-danger">กรุณากรอก {{labelProjectId}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.projectNameFlag == 'Y'">
        <label style="display: contents;">{{ labelProjectName }}</label
        ><span class="required" v-if="this.isRequiredProjectName">*</span>
        <input
          v-model="projectName"
          name="projectName"
          data-vv-as="ข้อมูล"
          v-validate="{ required: this.isRequiredProjectName }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('projectName') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('projectName')" class="help is-danger">กรุณากรอก {{labelProjectName}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.productTypeFlag == 'Y'">
        <label style="display: contents;">{{ labelProductType }}</label
        ><span class="required" v-if="this.isRequiredProductType">*</span>
        <input
          v-model="productType"
          name="productType"
          data-vv-as="ข้อมูล"
          v-validate="{ required: this.isRequiredProductType }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('productType') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('productType')" class="help is-danger">กรุณากรอก {{labelProductType}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.collectionPhaseFlag == 'Y'" >
        <label style="display: contents;">งวดเงินทั้งหมด(เริ่มต้น/สิ้นสุด)</label><span class="required" v-if="this.isRequiredCollectionPhase">*</span>
        <input
          v-model="collectionPhase"
          name="collectionPhase"
          data-vv-as="งวดเงินทั้งหมด(เริ่มต้น/สิ้นสุด)"
          v-validate="{ required: this.isRequiredCollectionPhase }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('collectionPhase') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('collectionPhase')" class="help is-danger">{{
          errors.first("collectionPhase")
        }}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.projectBudgetAmtFlag == 'Y'">
        <label style="display: contents;">{{ labelProjectBudgetAmt }}</label
        ><span class="required" v-if="this.isRequiredProjectBudgetAmt">*</span>
        <vue-numeric
          v-model="projectBudgetAmt"
          name="projectBudgetAmt"
          v-bind:precision="2"
          data-vv-as="มูลค่าขั้นต่ำของคลื่นความถี่"
          v-validate="{ required: this.isRequiredProjectBudgetAmt }"
          @keypress="isNumber($event)"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('projectBudgetAmt') }"
          class="form-control"
        ></vue-numeric>
        <span v-show="errors.has('projectBudgetAmt')" class="help is-danger">{{
          errors.first("projectBudgetAmt")
        }}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.seqNoFlag == 'Y'" >
        <label style="display: contents;">ลำดับผู้ยื่นคำขอตามคลื่นความถี่</label><span class="required" v-if="this.isRequiredSeqNo">*</span>
        <input
          v-model="seqNo"
          name="seqNo"
          data-vv-as="ลำดับผู้ยื่นคำขอตามคลื่นความถี่"
          v-validate="{ required: this.isRequiredSeqNo }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('seqNo') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('seqNo')" class="help is-danger">{{
          errors.first("seqNo")
        }}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.bidExpireDateFlag == 'Y'">
        <label>{{ labelBidExpireDate }}</label><span class="required" v-if="this.isRequiredBidExpireDate">*</span>
        <date-picker
          v-model="bidExpireDate"
          name="bidExpireDate"
          ref="bidExpireDate"
          format="DD/MM/YYYY"
          data-vv-as="วันที่สิ้นสุดการวางหลักประกัน"
          :editable="false"
          v-validate="{ required: this.isRequiredBidExpireDate }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :not-before="new Date()"
          lang="th"
          :class="{ input: true, 'is-danger': errors.has('bidExpireDate') }"
          placeholder
        ></date-picker>
        <span v-show="errors.has('bidExpireDate')" class="help is-danger">กรุณากรอก {{ labelBidExpireDate }}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.guaranteePriceAmtFlag == 'Y'">
        <label>{{ labelGuaranteePriceAmt }}</label><span class="required" v-if="this.isRequiredGuaranteePriceAmt">*</span>
        <vue-numeric
          v-model="guaranteePriceAmt"
          name="guaranteePriceAmt"
          v-bind:precision="2"
          data-vv-as="จํานวนเงินในการวางประกัน"
          @keypress="isNumber($event)"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          v-validate="{ required: this.isRequiredGuaranteePriceAmt, min_value: 0.01}"
          :class="{ input: true, 'is-danger': errors.has('guaranteePriceAmt') }"
          class="form-control"
        ></vue-numeric>
        <span v-show="errors.has('guaranteePriceAmt')" class="help is-danger">{{ labelGuaranteePriceAmt }} ต้องมีค่ามากกว่า 0</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.percentageFlag == 'Y'">
        <label>{{labelPercentage}}</label><span class="required" v-if="this.isRequiredPercentage">*</span>
        <vue-numeric
          v-model="percentage"
          name="percentage"
          v-bind:precision="2"
          data-vv-as="อัตราร้อยละ ในการวางหลักประกัน"
          @keypress="isNumber($event)"
          @blur="validPercent()"
          v-validate="{
            required: this.isRequiredPercentage,
            min_value: 0.01,
            max_value: 100.0,
          }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('percentage') }"
          class="form-control"
        ></vue-numeric>
        <span v-show="errors.has('percentage')" class="help is-danger">กรุณากรอก {{labelPercentage}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.contractPeriodFlag == 'Y'">
        <label>งวดที่ประกันผลงาน</label><span class="required" v-if="this.isRequiredContractPeriod">*</span>
        <input
          v-model="contractPeriod"
          name="contractPeriod"    
          data-vv-as="งวดที่ประกันผลงาน"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('contractPeriod') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('contractPeriod')" class="help is-danger">{{
          errors.first("contractPeriod")
        }}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-6" v-if="this.specificVo.advancePaymentAmtFlag == 'Y'">
        <label>เงินค่าจ้างล่วงหน้า</label><span class="required" v-if="this.isRequiredAdvancePaymentAmtAmt">*</span>
        <vue-numeric
          v-model="advancePaymentAmt"
          name="advancePaymentAmt"
          v-bind:precision="2"
          data-vv-as="เงินค่าจ้างล่วงหน้า"
          @keypress="isNumber($event)"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('advancePaymentAmt') }"
          class="form-control"
        ></vue-numeric>
        <span v-show="errors.has('advancePaymentAmt')" class="help is-danger">{{
          errors.first("advancePaymentAmt")
        }}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-12" v-if="this.specificVo.projectOwnerFlag == 'Y'">
        <label>{{ labelProjectOwner}}</label><span class="required" v-if="this.isRequiredProjectOwner">*</span>
        <input
          v-model="projectOwner"
          name="projectOwner"    
          data-vv-as="ข้อมูล"
          v-validate="{ required: this.isRequiredProjectOwner }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('projectOwner') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('projectOwner')" class="help is-danger">กรุณากรอก {{labelProjectOwner}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-12" v-if="this.specificVo.manyCtrNoFlag == 'Y'">
        <label>{{labelManyCtrNo}}</label><span class="required" v-if="this.isRequiredManyCtrNo">*</span>
        <input
          v-model="manyCtrNo"
          name="manyCtrNo"
          data-vv-as="เลขที่สัญญา ตั้งแต่ฉบับที่ 2"
          v-validate="{ required: this.isRequiredManyCtrNo }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('manyCtrNo') }"
          maxlength="400"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('manyCtrNo')" class="help is-danger">กรุณากรอก {{labelManyCtrNo}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-12" v-if="this.specificVo.manyCtrDateFlag == 'Y'">
        <label>{{labelManyCtrDate}}</label><span class="required" v-if="this.isRequiredManyCtrDate">*</span>
        <input
          v-model="manyCtrDate"
          name="manyCtrDate"
          data-vv-as="สัญญาลงวันที่ ตั้งแต่ฉบับที่ 2: (yyyy-mm-dd,yyyy-mm-dd,....)"
          v-validate="{ required: this.isRequiredManyCtrDate }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('manyCtrNo') }"
          maxlength="400"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('manyCtrDate')" class="help is-danger">กรุณากรอก {{labelManyCtrDate}}</span>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group col-md-12" v-if="this.specificVo.manyCtrNameFlag == 'Y'">
        <label>{{labelManyCtrName}}</label><span class="required" v-if="this.isRequiredManyCtrName">*</span>
        <input
          v-model="manyCtrName"
          name="manyCtrName"
          data-vv-as="ชื่อสัญญาที่ค้ำประกันเพิ่มเติม กรณีมีสัญญาที่ค้ำประกันตั้งแต่สองฉบับขึ้นไป"
          v-validate="{ required: this.isRequiredManyCtrName }"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag !== 'Y'"
          :class="{ input: true, 'is-danger': errors.has('manyCtrNo') }"
          maxlength="500"
          type="text"
          class="form-control"
        />
        <span v-show="errors.has('manyCtrName')" class="help is-danger">กรุณากรอก {{labelManyCtrName}}</span>
      </div>
    </div>
    
  </div>
</template>

<script>
//import DatePicker from "vue2-datepicker";
import DatePicker from "@/resources/datepicker/vue2-datepicker";
import moment from "moment";
import { apiClient } from "@/utils/apiClient";
import { tsImportEqualsDeclaration } from "@babel/types";

export default {
  inject: ["$validator"],
  props: ["reqType", "appVo", "lgType", "lgFormNo", "beneGroup", "beneTaxId"],
  components: {
    DatePicker,
  },
  data() {
    return {
      caNo:"",
      meterNo:"",
      ctrNo: "",
      ctrName: "",
      ctrDate: "",
      beneficiaryRemark: "",
      txtCtrNo: "เลขที่สัญญา",
      txtCtrName: "ชื่อสัญญา",
      txtCtrDate: "วันที่ลงสัญญา",
      specificVo: [],
      isRequiredCtrNo: true,
      isRequiredCtrName: true,
      isRequiredCtrDate: true,
      isRequiredBeneRemark: true,
      isRequiredCtrDatePEA: false,
      isRequiredPercentage: false,
      isRequiredProjectName: false,
      isRequiredManyCtrNo: false,
      isRequiredManyCtrDate: false,
      isRequiredGuaranteePriceAmt: true,
      isRequiredContractPeriod: false,
      isRequiredProjectId: true,
      isRequiredProjectBudgetAmt: true,
      isRequiredSeqNo: true,
      isRequiredBidExpireDate: true,
      isRequiredProjectOwner: true,
      isRequiredAdvancePaymentAmtAmt: true,
      isRequiredCollectionPhase: true,
      isRequiredProductType: true,
      isRequiredDealerCode: true,
      isRequiredManyCtrName: false,
      isRequiredLgDescription3: false,
      ctrDatePEA: "",
      projectName: "",
      percentage: "",
      labelProjectName: "ชื่อโครงการ (Project Name)",
      labelBeneRemark: "รายละเอียดโครงการ/รายละเอียดสัญญา",
      labelProjectId: "เลขที่โครงการ",
      labelGuaranteePriceAmt: "จํานวนเท่าในการวางประกัน",
      labelProjectOwner: "ชื่อหน่วยงาน",
      labelProductType: "ประเภทสินค้า",
      labelDealerCode: "รหัสของตัวแทนจำหน่าย",
      labelBidExpireDate: "วันที่สิ้นสุดการวางหลักประกัน",
      labelPercentage: "อัตราร้อยละ ในการวางหลักประกัน",
      labelProjectBudgetAmt: "มูลค่าขั้นต่ำของคลื่นความถี่",
      labelManyCtrNo: "เลขที่สัญญา ตั้งแต่ฉบับที่ 2: (xxx1,xxx2,....)",
      labelManyCtrDate: "สัญญาลงวันที่ ตั้งแต่ฉบับที่ 2: (yyyy-mm-dd,yyyy-mm-dd,....)",
      labelManyCtrName: "ชื่อสัญญาที่ค้ำประกันเพิ่มเติม กรณีมีสัญญาที่ค้ำประกันตั้งแต่สองฉบับขึ้นไป",
      labelLgDescription3: "ชื่อสัญญาหลัก",
      lgTypeVo: "",
      modifyFlag: "",
      manyCtrNo: "",
      manyCtrDate: "",
      guaranteePriceAmt: "",
      hospitalCode: "",
      hospitalName: "",
      contractTypeId: 0,
      contractTypeDesc: "",
      contractTypeList: [],
      contractPeriod:"",
      projectId:"",
      seqNo:"",
      projectBudgetAmt:"",
      bidExpireDate:"",
      projectOwner:"",
      advancePaymentAmt:"",
      collectionPhase:"",
      productType:"",
      dealerCode:"",
      manyCtrName:"",
      lgDescription3:"",
      passDay: moment(new Date(), "DD/MM/YYYY")
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.percentage = "";
      // initial ค่ากรณีที่เป็น ต่ออายุและ เพิ่มวงเงิน
      if (this.appVo) {
        this.caNo = this.appVo.caNo;
        this.meterNo = this.appVo.meterNo;
        this.ctrNo = this.appVo.ctrNo;
        this.ctrName = this.appVo.ctrName;
        this.ctrDate = moment(this.appVo.ctrDate, "DD/MM/YYYY");
        this.beneficiaryRemark = this.appVo.beneficiaryRemark;
        this.beneGroup = this.appVo.beneGroup;
        this.lgTypeVo = this.appVo.contingentTypeId;
        //this.lgFormNo = this.appVo.lgFormNo;
        //this.lgFormNo = this.lgFormNo;
        this.projectName = this.appVo.projectName;
        this.ctrDatePEA = moment(this.appVo.ctrDatePEA, "DD/MM/YYYY");
        this.percentage = this.appVo.percentage;
        this.modifyFlag = this.appVo.modifyFlag;
        this.manyCtrNo = this.appVo.manyCtrNo;
        this.manyCtrDate = this.appVo.manyCtrDate;
        this.guaranteePriceAmt = this.appVo.guaranteePriceAmt;
        this.hospitalCode = this.appVo.hospitalCode;
        this.hospitalName = this.appVo.hospitalName;
        this.contractTypeId = this.appVo.contractTypeId;
        this.contractTypeDesc = this.appVo.contractTypeDesc;
        this.contractPeriod = this.appVo.contractPeriod;
        this.projectId = this.appVo.projectId;
        this.seqNo = this.appVo.seqNo;
        this.projectBudgetAmt = this.appVo.projectBudgetAmt;
        this.bidExpireDate = moment(this.appVo.bidExpireDate, "DD/MM/YYYY");
        this.projectOwner = this.appVo.projectOwner;
        this.advancePaymentAmt = this.appVo.advancePaymentAmt;
        this.collectionPhase = this.appVo.collectionPhase;
        this.productType = this.appVo.productType;
        this.dealerCode = this.appVo.dealerCode;
        this.manyCtrName = this.appVo.manyCtrName;
        this.lgDescription3 = this.appVo.lgDescription3;
        this.getSpecificField();
      } else {
        this.lgTypeVo = this.lgType;
        this.getSpecificField();
        if(this.beneGroup === "MU"){
          this.projectOwner = "คณะแพทยศาสตร์โรงพยาบาลรามาธิบดี";
        }
      }
    });

  },
  watch: {
    caNo() {
      this.emitDataToParent();
    },
    meterNo() {
      this.emitDataToParent();
    },
    ctrNo() {
      this.emitDataToParent();
    },
    ctrName() {
      this.emitDataToParent();
    },
    ctrDate() {
      this.emitDataToParent();
    },
    beneficiaryRemark() {
      this.emitDataToParent();
    },
    ctrDatePEA() {
      this.emitDataToParent();
    },
    projectName() {
      this.emitDataToParent();
    },
    percentage() {
      this.emitDataToParent();
    },
    manyCtrNo() {
      this.emitDataToParent();
    },
    manyCtrDate() {
      this.emitDataToParent();
    },
    guaranteePriceAmt() {
      this.emitDataToParent();
    },
    hospitalCode() {
      this.emitDataToParent();
    },
    hospitalName() {
      this.emitDataToParent();
    },
    contractTypeId() {
      this.emitDataToParent();
    },
    contractPeriod() {
      this.emitDataToParent();
    },
    projectId() {
      this.emitDataToParent();
    },
    seqNo() {
      this.emitDataToParent();
    },
    projectBudgetAmt() {
      this.emitDataToParent();
    },
    bidExpireDate() {
      this.emitDataToParent();
    },
    projectOwner() {
      this.emitDataToParent();
    },
    advancePaymentAmt() {
      this.emitDataToParent();
    },
    collectionPhase() {
      this.emitDataToParent();
    },
    productType() {
      this.emitDataToParent();
    },
    dealerCode() {
      this.emitDataToParent();
    },
    manyCtrName() {
      this.emitDataToParent();
    },
    lgDescription3() {
      this.emitDataToParent();
    },
  },
  methods: {
    gethospitalName() {
      this.loader = this.$loading.show();
      this.hospitalName = "";
      if (this.hospitalCode) {
        apiClient
          .get("/api/home/getHospitalName/" + this.hospitalCode)
          .then((res) => {
            this.loader.hide();
            if (res && res.data) {
              this.hospitalName = res.data.hospitalName;
            }else{
              this.hospitalCode = "";
                this.$swal("Error", "ไม่พบข้อมูลสถานบริการ กรุณาตรวจสอบรหัสสถานบริการ", "error");
                return;
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    async getSpecificField() {
      this.txtCtrNo = "เลขที่สัญญา";
      this.txtCtrDate = "วันที่ลงสัญญา";
      this.labelProjectName = "ชื่อโครงการ (Project Name)";
      this.labelBeneRemark = "รายละเอียดโครงการ/รายละเอียดสัญญา";
      this.isRequiredCtrNo = true;
      this.isRequiredCtrName = true;
      this.isRequiredCtrDate = true;
      this.isRequiredCtrDatePEA = false;
      this.isRequiredPercentage = false;
      this.isRequiredProjectName = false;

      if (
        this.beneGroup !== "" &&
        this.lgTypeVo &&
        this.lgFormNo !== "" &&
        this.beneTaxId !== ""
      ) {
        apiClient
          .get(
            "/api/home/getSpecificField/" +
              this.beneGroup +
              "/" +
              this.lgTypeVo +
              "/" +
              this.lgFormNo
          )
          .then((resp) => {
            this.specificVo = resp.data;
            console.log(
              "this.specificVo.hcodeFlag :" + this.specificVo.hcodeFlag
            );
            //for optional field BCI
            if (this.beneGroup === "BCP" || this.beneGroup === "BRIDGE") {
              if (
                this.beneTaxId === "0107536000269" ||
                this.beneTaxId === "0105536080112"
              ) {
                //bangchak
                this.labelProjectName = "วัตถุประสงค์การยื่นซองประกวดราคา/ชื่อโครงการ/วัตถุประสงค์การก่อหนี้";
                if (this.lgTypeVo == 3) {
                  this.isRequiredCtrName = true;
                  this.isRequiredCtrDate = true;
                  this.isRequiredProjectName = true;
                } else if (this.lgTypeVo == 7) {
                  this.isRequiredProjectName = true;
                  this.isRequiredCtrName = false;
                }
              } else {
                if (this.specificVo.ctrNameFlag === "Y") {
                  this.isRequiredCtrName = false;
                }
                if (this.specificVo.ctrDateFlag === "Y") {
                  this.isRequiredCtrDate = false;
                }
              }
            } else if (this.specificVo.beneGroup === "PEA") {
              this.txtCtrNo = "เลขที่สัญญา";
              if (
                this.specificVo.conitngentTypeId === "2" ||
                this.specificVo.conitngentTypeId === "9" ||
                (this.specificVo.conitngentTypeId === "3" &&
                  (this.lgFormNo === "PEACABLE_PER_001_TH" ||
                   this.lgFormNo === "PEACABLE_PER_002_TH" ||
                   this.lgFormNo === "PEACABLE_PER_003_TH" ||
                   this.lgFormNo === "PEACABLE_PER_004_TH"))
              ) {
                this.isRequiredCtrDatePEA = true;
              }
              if (
                this.specificVo.conitngentTypeId === "3" ||
                this.specificVo.conitngentTypeId === "7"
              ) {
                this.isRequiredProjectName = true;
              }
              if (
                this.specificVo.conitngentTypeId === "3" ||
                this.specificVo.conitngentTypeId === "7" ||
                this.specificVo.conitngentTypeId === "9"
              ) {
                this.isRequiredPercentage = true;
              }
            } else if (this.specificVo.beneGroup === "AIS" || this.specificVo.beneGroup === "SCCC") {
              if (this.specificVo.conitngentTypeId === "1") {
                this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                this.txtCtrDate = "เอกสารการประกวดราคาลงวันที่";
                this.labelProjectName = "วัตถุประสงค์การยื่นซองประกวดราคา/ชื่อโครงการ/วัตถุประสงค์การก่อหนี้";
                this.labelBeneRemark = "วัตถุประสงค์การยื่นซองประกวดราคา/ชื่อโครงการ/วัตถุประสงค์การก่อหนี้";
                this.isRequiredCtrName = false;
                this.isRequiredProjectName = true;
                this.isRequiredBeneRemark = true;
                if(this.specificVo.beneGroup === "SCCC"){
                  this.isRequiredCtrNo = false;
                  this.isRequiredCtrDate = false;
                }
              } else if (this.specificVo.conitngentTypeId === "9") {
                this.isRequiredCtrDate = false;
                if(this.specificVo.beneGroup === "SCCC"){
                  this.isRequiredCtrDate = true;
                }
              }
            } else if (this.specificVo.beneGroup === "SHELL") {
              this.isRequiredCtrNo = false;
              this.isRequiredBeneRemark = false;
              this.labelBeneRemark = "รายละเอียดสัญญา/โครงการ(Contract/ Project Description)";
            } else if (this.specificVo.beneGroup === "NHSO") {
              this.isRequiredCtrNo = false;
              this.getContractTypeList();
            } else if(this.specificVo.beneGroup === "VNT"){
              if (this.specificVo.conitngentTypeId === "7") {
                  this.isRequiredCtrName = false;
                  this.isRequiredBeneRemark = false;
                  this.labelBeneRemark = "วัตถุประสงค์ของหนังสือค้ำประกัน";
              }
              if (this.specificVo.conitngentTypeId === "1") {
                  this.isRequiredCtrNo = false;
                  this.isRequiredCtrDate = false;
                  this.isRequiredBeneRemark = false;
                  this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                  this.txtCtrDate = "เอกสารการประกวดราคาลงวันที่";
                  this.labelBeneRemark = "วัตถุประสงค์การยื่นซองประกวดราคา/ ชื่องานที่ประมูล/ ชื่อโครงการ";
              }
              if(this.specificVo.conitngentTypeId === "2" || this.specificVo.conitngentTypeId === "3" || this.specificVo.conitngentTypeId === "9"){
                  this.isRequiredCtrNo = false;
                  this.isRequiredCtrDate = false;
                  this.isRequiredCtrName = false;
                  this.isRequiredBeneRemark = false;
                  this.txtCtrNo = "เลขที่สัญญา/เลขที่ PO";
              }
            }else if(this.specificVo.beneGroup === "CTL"){
              this.labelProjectOwner = "ชื่อย่อประเภทของธุรกิจ";
              if(this.lgFormNo === "CTL_GEN_PER_901_TH" || this.lgFormNo === "CTL_GEN_PER_902_TH"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrName = false;
                this.isRequiredBeneRemark = false;
                this.isRequiredCtrDate = true;
                this.txtCtrNo = "เลขที่คำขอใช้วงเงินสินเชื่อ";
                this.txtCtrName = "ชื่อสัญญาซื้อขายผลิตภัณฑ์ปิโตรเลียม";
                this.txtCtrDate = "วันที่ลงนามคำขอใช้วงเงินสินเชื่อ";
                this.labelBeneRemark = "สัญญาการใช้บัตร Star Card";
              }else{
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = true;
                this.txtCtrNo = "เลขที่สิทธิในการค้าปลีกน้ำมันของเชฟรอน";
                this.txtCtrDate = "วันที่ลงนามสิทธิในการค้าปลีกน้ำมันของเชฟรอน";
              }
            }else if(this.specificVo.beneGroup === "NBTC"){
              this.isRequiredProjectName = true;
              this.isRequiredPercentage = true;
              this.labelProjectName = "ชื่อโครงการ";
              this.labelGuaranteePriceAmt = "จำนวนเงินของหลักประกัน";
              if(this.lgFormNo === "NBTC_BID_001_TH"){                
                this.txtCtrNo = "เลขที่เอกสาร";
                this.txtCtrDate = "วันที่ยื่นคำขอรับใบอนุญาต";
              }
              if(this.lgFormNo ==="CGD_ADV_001_TH" || this.lgFormNo ==="CGD_ADV_002_TH" || this.lgFormNo ==="CGD_RET_001_TH"){
                this.isRequiredProjectId = false;
                this.isRequiredProjectName = false;
                this.isRequiredGuaranteePriceAmt = false;
              }
            }else if(this.specificVo.beneGroup === "BGP"){
                this.labelBeneRemark = "วัตถุประสงค์ของหนังสือค้ำประกัน";
                if(this.specificVo.conitngentTypeId === "3"){
                  this.txtCtrNo = "เลขที่สัญญา/เลขที่ PO";
                  this.isRequiredCtrNo = false;
                  this.isRequiredBeneRemark = false;
                }
            }
            else if(this.specificVo.beneGroup === "CPN"){
              if (this.specificVo.conitngentTypeId === "1") {
                this.txtCtrNo = "เลขที่เอกสารประกวดราคา / เลขที่ TOR";
                this.txtCtrDate = "วันที่ TOR";
                this.labelBeneRemark = "วัตถุประสงค์การยื่นซองประกวดราคา/ ชื่องานที่ประมูล/ ชื่อโครงการ";
              }else if(this.specificVo.conitngentTypeId === "7"){
                this.labelBeneRemark = "วัตถุประสงค์ของหนังสือค้ำประกัน";
              }
            }
            else if(this.specificVo.beneGroup === "SKC"){
              if (this.specificVo.conitngentTypeId === "1") {
                this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "วัตถุประสงค์การยื่นซองประกวดราคา/ ชื่องานที่ประมูล/ ชื่อโครงการ";
              }else if (this.specificVo.conitngentTypeId === "3" || this.specificVo.conitngentTypeId === "9") {
                this.txtCtrNo = "เลขที่สัญญา/เลขที่ PO";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "รายละเอียดสัญญา/โครงการ";
              }
            }else if(this.specificVo.beneGroup === "PTTNGD"){
              this.labelProjectOwner = "ชื่อของบริษัทที่ต้องการขอออกหนังสือค้ำประกัน";
              if (this.specificVo.conitngentTypeId === "1") {
                this.txtCtrNo = "เลขที่เอกสารประกวดราคา";
                this.txtCtrDate = "วันที่เอกสารประกวดราคา";
                this.labelProjectName = "ชื่อโครงการ";
                this.labelBidExpireDate = "วันที่สิ้นสุดการยื่นซอง";
                this.labelGuaranteePriceAmt = "จำนวนเงินของหลักประกัน";                
                this.isRequiredCtrDate = false;
                this.isRequiredProjectId = false;
                this.isRequiredProjectName = true;
              }else if(this.specificVo.conitngentTypeId === "3"){
                if(this.lgFormNo ==="NGD_PER_003_TH" || this.lgFormNo ==="NGD_PER_003_EN"){
                  this.txtCtrNo = "ฉบับเลขที่ของสัญญา/หนังสือสนอง/ใบสั่ง (ซื้อ/จ้าง/เช่า)";
                  this.txtCtrDate = "วันที่ทำสัญญา/หนังสือสนอง/ใบสั่ง (ซื้อ/จ้าง/เช่า)";
                  this.txtCtrName = "ชื่อของสัญญา/หนังสือสนอง/ใบสั่ง (ซื้อ/จ้าง/เช่า)";
                  this.labelBeneRemark = "วัตถุประสงค์การยื่นซองประกวดราคา/ ชื่อโครงการ  / รายละเอียดวัตถุประสงค์การก่อหนี้";
                  this.isRequiredCtrDate = false;
                }else if(this.lgFormNo ==="NGD_PER_001_TH" || this.lgFormNo ==="NGD_PER_002_TH"){
                  this.txtCtrDate = "วันที่สัญญา";
                  this.labelProjectName = "ชื่อโครงการ";
                  this.labelGuaranteePriceAmt = "จำนวนเงินของหลักประกัน";  
                  this.labelPercentage = "หลักประกันคิดเป็นอัตราร้อยละ/อัตราร้อยละของเงินประกันผลงาน";
                  this.isRequiredCtrDate = false;
                  this.isRequiredProjectName = true;
                }
              }else if(this.specificVo.conitngentTypeId === "7"){
                this.txtCtrNo = "เลขที่สัญญาประธาน";
                this.txtCtrName = "ลักษณะของมูลหนี้";
                this.txtCtrDate = "วันที่ทำสัญญาประธาน";
                this.labelBeneRemark = "วัตถุประสงค์ในการก่อหนี้";
                this.isRequiredCtrDate = false;
              }else if(this.specificVo.conitngentTypeId === "9"){
                this.txtCtrNo = "ฉบับเลขที่ของสัญญา";
                this.txtCtrName = "ชื่อของสัญญา";
                this.labelProjectName = "ชื่อโครงการ";
                this.isRequiredCtrDate = false;
              }  
            }else if(this.specificVo.beneGroup === "ESSO"){
              this.labelProjectName = "ชื่อโครงการ";
              this.txtCtrDate = "สัญญาลงวันที่";
              
              if(this.lgFormNo ==="ESSO_PER_901_TH"){
                this.isRequiredCtrNo = false;
                this.isRequiredCtrName = true;
                this.isRequiredCtrDate = false;
                this.isRequiredProjectName = false;
              }else if(this.lgFormNo ==="ESSO_PER_901_EN"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrName = true;
                this.isRequiredCtrDate = false;
                this.isRequiredProjectName = false;
              }else{
                this.txtCtrName = "รายละเอียดของมูลหนี้ที่ก่อ";
                this.labelBeneRemark = "วัตถุประสงค์การก่อหนี้";
              }
            }else if(this.specificVo.beneGroup === "SKL"){
              if(this.lgFormNo ==="BCI_BID_904_TH"){
                this.isRequiredCtrNo = false;
                this.isRequiredCtrDate = false;
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = false;
                this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "วัตถุประสงค์การยื่นซองประกวดราคา / ชื่องานที่ประมูล / ชื่อโครงการ";
              }else if(this.lgFormNo ==="BCI_MER_903_TH"){
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = false;
                this.labelBeneRemark = "วัตถุประสงค์ของหนังสือค้ำประกัน";
              }else if(this.lgFormNo ==="BCI_ADV_902_TH" || this.lgFormNo ==="BCI_PER_911_TH" || this.lgFormNo ==="BCI_RET_908_TH"){
                this.isRequiredCtrNo = false;
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = false;
                this.txtCtrNo = "เลขที่สัญญา/เลขที่ PO";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "รายละเอียดสัญญา/โครงการ";
              }else if(this.lgFormNo ==="BCI_RET_907_TH"){
                this.isRequiredCtrNo = false;
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = false;
                this.txtCtrNo = "เลขที่สัญญา/เลขที่ PO";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "รายละเอียดสัญญา/โครงการ";
              }
            }else if(this.specificVo.beneGroup === "MEA"){
              this.txtCtrDate = "สัญญาลงวันที่";
              this.txtCtrName = "ชื่อผู้ใช้ไฟฟ้า";
              this.labelBeneRemark = "เลขที่อ้างอิง";
            }else if(this.specificVo.beneGroup === "DOHOME"){
              this.txtCtrNo = "เลขที่สัญญา/เลขที่ PO";
              this.txtCtrDate = "สัญญาลงวันที่";
              this.labelBeneRemark = "รายละเอียดโครงการ / รายละเอียดสัญญา";
              this.isRequiredCtrNo = false;
              this.isRequiredCtrDate = false;
              this.isRequiredBeneRemark = false;
              this.isRequiredProjectOwner = false;
              if(this.lgFormNo ==="BCI_MER_902_TH"){
                this.labelBeneRemark = "วัตถุประสงค์ของหนังสือค้ำประกัน";
              }else if(this.lgFormNo ==="BCI_RET_905_TH" || this.lgFormNo ==="BCI_RET_906_TH"){
                this.isRequiredBeneRemark = true;
              }
            }else if(this.specificVo.beneGroup === "MU"){
              this.isRequiredCtrNo = true;
              this.isRequiredCtrDate = true;
              this.isRequiredProjectOwner = true;
              this.isRequiredGuaranteePriceAmt = true;
              this.isRequiredContractPeriod = true;
              this.isRequiredProjectId = true;
              this.isRequiredProjectName = true;
              this.isRequiredProjectBudgetAmt = true;
              this.isRequiredPercentage = true;
              this.labelProjectName = "ชื่อโครงการ";
              this.labelProjectBudgetAmt = "วงเงินโครงการ";
              this.labelGuaranteePriceAmt = "จำนวนเงินของหลักประกัน";
              this.labelPercentage = "หลักประกันคิดเป็นอัตราร้อยละ/อัตราร้อยละของเงินประกัน";
              this.txtCtrDate = "สัญญาลงวันที่";
              if(this.lgFormNo ==="RAMAGOV_BID_001_TH"){
                this.isRequiredCtrDate = false;
                this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                this.txtCtrDate = "วันที่เอกสารประกวดราคา";
                this.labelBidExpireDate = "วันที่สิ้นสุดการยื่นซอง";                
              }
            }else if(this.specificVo.beneGroup === "COMSEVEN"){
              if(this.specificVo.conitngentTypeId === "7"){
                this.isRequiredBeneRemark = false;
                this.labelBeneRemark = "รายละเอียดสัญญา/โครงการ";
              }else if(this.specificVo.conitngentTypeId === "1"){
                this.isRequiredCtrDate = false;
                this.isRequiredProjectName = false;
                this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                this.txtCtrDate = "วันที่เอกสารประกวดราคา";
                this.labelProjectName = "ชื่อโครงการ";
              }else if(this.specificVo.conitngentTypeId === "3"){
                this.isRequiredCtrDate = false;
                this.isRequiredBeneRemark = false;
              }else if(this.specificVo.conitngentTypeId === "9"){
                this.isRequiredCtrDate = false;
                this.isRequiredBeneRemark = false;
                this.txtCtrDate = "วันที่สัญญา";
                this.labelBeneRemark = "รายละเอียดสัญญา/โครงการ";
                if(this.lgFormNo ==="BCI_RET_910_TH" || this.lgFormNo ==="BCI_RET_910_EN"){
                  this.txtCtrNo = "เลขที่สัญญา/เลขที่ PO";
                }
              }
            }else if(this.specificVo.beneGroup === "GCL"){
              if(this.specificVo.conitngentTypeId === "1"){
                this.isRequiredCtrDate = false;
                this.isRequiredProjectName = true;
                this.txtCtrDate = "วันที่ประกาศจัดซื้อจัดจ้าง";
                this.labelProjectName = "ชื่อโครงการ";
              }else if(this.specificVo.conitngentTypeId === "2"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = true;
                this.isRequiredBeneRemark = true;
                this.txtCtrNo = "เลขที่ PO";
                this.txtCtrDate = "วันที่ในสัญญา / วันที่เริ่มโครงการ";
                this.labelBeneRemark = "รายละเอียดโครงการ / วัตถุประสงค์ค้ำประกัน";
              }else if(this.specificVo.conitngentTypeId === "3"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = true;
                this.isRequiredBeneRemark = true;
                this.txtCtrNo = "เลขที่สัญญา";
                this.txtCtrDate = "วันที่ในสัญญา / วันที่เริ่มโครงการ";
                this.labelBeneRemark = "รายละเอียดสัญญา / โครงการ";
              }else if(this.specificVo.conitngentTypeId === "7"){
                this.isRequiredCtrDate = false;
                this.isRequiredBeneRemark = false;
                this.txtCtrDate = "วันที่ในสัญญา / วันที่เริ่มโครงการ";
                this.labelBeneRemark = "รายละเอียดสัญญา / โครงการ";
              }else if(this.specificVo.conitngentTypeId === "9"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = true;
                this.isRequiredBeneRemark = true;
                this.txtCtrNo = "เลขที่ PO";
                this.txtCtrDate = "วันที่ในสัญญา / วันที่เริ่มโครงการ";
                this.labelBeneRemark = "รายละเอียดสัญญา / โครงการ";
              }
            }else if(this.specificVo.beneGroup === "EASTW"){
              if(this.specificVo.conitngentTypeId === "1"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = false;
                this.isRequiredProjectName = false;
                this.isRequiredProjectOwner = true;
                this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                this.txtCtrDate = "วันที่เอกสารประกวดราคา";
                this.labelProjectName = "ชื่อโครงการ";
              }else if(this.specificVo.conitngentTypeId === "2"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrName = true;
                this.isRequiredCtrDate = false;
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = true;
                this.txtCtrNo = "เลขที่สัญญา / เลขที่ PO";
                this.txtCtrName = "ชื่อสัญญา";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "รายละเอียดสัญญา / โครงการ";
              }else if(this.specificVo.conitngentTypeId === "3" || this.specificVo.conitngentTypeId === "9"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrName = true;
                this.isRequiredCtrDate = false;
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = true;
                this.txtCtrNo = "เลขที่สัญญา";
                this.txtCtrName = "ชื่อสัญญา";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "รายละเอียดสัญญา / โครงการ";
              }
            }else if(this.specificVo.beneGroup === "SSLC"){
              if(this.specificVo.conitngentTypeId === "1"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = true;
                this.isRequiredProjectName = true;
                this.isRequiredProjectOwner = true;
                this.txtCtrNo = "เลขที่เอกสารการประกวดราคา";
                this.txtCtrDate = "วันที่เอกสารประกวดราคา";
                this.labelProjectName = "ชื่อโครงการ";
              }else if(this.specificVo.conitngentTypeId === "2" || this.specificVo.conitngentTypeId === "3" || this.specificVo.conitngentTypeId === "9"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrName = true;
                this.isRequiredCtrDate = true;
                this.isRequiredBeneRemark = true;
                this.isRequiredProjectOwner = true;
                this.txtCtrNo = "เลขที่สัญญา";
                this.txtCtrName = "ชื่อสัญญา";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "รายละเอียดสัญญา / โครงการ";
                this.labelManyCtrNo = "เลขที่ของสัญญาที่ค้ำประกันเพิ่มเติม";
                this.labelManyCtrDate = "วันที่ของสัญญาที่ค้ำประกันเพิ่มเติม";
              }else if(this.specificVo.conitngentTypeId === "7"){
                this.isRequiredCtrName = true;
                this.isRequiredBeneRemark = true;
                this.isRequiredProjectOwner = true;
                this.txtCtrName = "ชื่อสัญญา";
                this.labelBeneRemark = "รายละเอียดสัญญา / โครงการ";
                this.labelManyCtrNo = "เลขที่ของสัญญาที่ค้ำประกันเพิ่มเติม";
                this.labelManyCtrDate = "วันที่ของสัญญาที่ค้ำประกันเพิ่มเติม";
              }
            }else if(this.specificVo.beneGroup === "SFL"){
              if(this.lgFormNo ==="SFL_GEN_PER_901_TH" || this.lgFormNo ==="SFL_GEN_PER_902_TH"){
                this.isRequiredCtrNo = false;
                this.isRequiredCtrName = false;
                this.isRequiredCtrDate = true;
                this.isRequiredBeneRemark = false;
                this.isRequiredProjectOwner = true;
                this.txtCtrNo = "ชื่อ และ/หรือ เลขที่สัญญา";
                this.txtCtrName = "ชื่อหลักฐานการซื้อขายผลิตภัณฑ์ปิโตรเลียม";
                this.txtCtrDate = "สัญญาลงวันที่";
                this.labelBeneRemark = "สัญญาการใช้บัตร Star Card";
                this.labelManyCtrNo = "เลขที่สัญญาที่ค้ำประกันเพิ่มเติม กรณีมีสัญญาที่ค้ำประกันตั้งแต่สองฉบับขึ้นไป";
                this.labelManyCtrDate = "วันที่ของสัญญาที่ค้ำประกันเพิ่มเติมกรณีมีสัญญาที่ค้ำประกันตั้งแต่สองฉบับขึ้นไป";
                this.labelProjectOwner="ชื่อย่อประเภทของธุรกิจ";
              }else if(this.lgFormNo ==="SFL_DML_PER_901_TH" || this.lgFormNo ==="SFL_EQU_PER_901_TH"){
                this.isRequiredCtrNo = true;
                this.isRequiredCtrDate = true;
                this.isRequiredProjectOwner = true;
                this.txtCtrNo = "เลขที่สัญญาให้สิทธิในการค้าปลีกน้ำมัน";
                this.txtCtrDate = "วันที่ลงนามสัญญาให้สิทธิในการค้าปลีกน้ำมัน";
                this.labelManyCtrNo = "เลขที่สัญญาให้สิทธิในการค้าปลีกน้ำมันที่ค้ำประกันเพิ่มเติม กรณีมีสัญญาที่ค้ำประกันตั้งแต่สองฉบับขึ้นไป";
                this.labelManyCtrDate = "วันที่ลงนามสัญญาให้สิทธิในการค้าปลีกน้ำมันที่ค้ำประกันเพิ่มเติม กรณีมีสัญญาที่ค้ำประกันตั้งแต่สองฉบับขึ้นไป";
                this.labelProjectOwner="ชื่อย่อประเภทของธุรกิจ";
              }
            }
          })
          .catch((error) => {});
      }
    },
    getContractTypeList() {
      this.contractTypeList = [];
      apiClient
        .get("/api/home/getContractTypeList")
        .then((resp) => {
          if (resp && resp.data) {
            this.contractTypeList = resp.data;
            if (this.contractTypeId && this.contractTypeDesc) {
              this.contractTypeId = {
                contractTypeId: this.contractTypeId,
                contractTypeDesc: this.contractTypeDesc,
              };
            } else {
              this.contractTypeId = {
                contractTypeId: resp.data[0].contractTypeId,
                contractTypeDesc: resp.data[0].contractTypeDesc,
              };
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    emitDataToParent() {
      this.$emit("childToParent", {
        caNo: this.caNo,
        meterNo: this.meterNo,
        ctrNo: this.ctrNo,
        ctrName: this.ctrName,
        ctrDate: this.ctrDate,
        beneficiaryRemark: this.beneficiaryRemark,
        ctrDatePEA: this.ctrDatePEA,
        projectName: this.projectName,
        percentage: this.percentage,
        manyCtrNo: this.manyCtrNo,
        manyCtrDate: this.manyCtrDate,
        guaranteePriceAmt: this.guaranteePriceAmt,
        hospitalCode: this.hospitalCode,
        hospitalName: this.hospitalName,
        contractTypeId: this.contractTypeId.contractTypeId,
        contractTypeDesc: this.contractTypeId.contractTypeDesc,
        contractPeriod: this.contractPeriod,
        projectId: this.projectId,
        seqNo: this.seqNo,
        projectBudgetAmt: this.projectBudgetAmt,
        bidExpireDate: this.bidExpireDate,
        projectOwner: this.projectOwner,
        advancePaymentAmt: this.advancePaymentAmt,
        collectionPhase: this.collectionPhase,
        productType: this.productType,
        dealerCode: this.dealerCode,
        manyCtrName: this.manyCtrName,
        lgDescription3: this.lgDescription3
      });
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isKeypress: function(evt) {
      evt = evt ? evt : window.event;
      evt.preventDefault();
    },
    validPercent() {
      if (100 < this.percentage) {
        this.percentage = "100.00";
      }
    },
  },
};
</script>
<style>
.required {
  font-weight: bold;
  color: red;
  font-size: 1.5em;
}
</style>
